import AsyncStorage from '@react-native-async-storage/async-storage';
import {APP_TYPE, clientConfigPathMaster} from '../../config/Constant';
import {
  hotelSelectorFailure,
  hotelSelectorRequest,
  hotelSelectorSuccess,
} from '../Reducers/hotelSelectorReducer';

export const getHotelList = () => {
  return async dispatch => {
    dispatch(hotelSelectorRequest());

    let corporateSessionToken = await AsyncStorage.getItem('corporateSessionToken');

    const config = {
      headers: {
        Authorization: `Bearer ${corporateSessionToken}`,
      },
    };
    try {
      let response = await clientConfigPathMaster.get(
        `/multiHotelApp/hotels?appType=${APP_TYPE}`,
        config,
      );
      dispatch(hotelSelectorSuccess({hotelListData: response.data}));
    } catch (error) {
      dispatch(hotelSelectorFailure());
    }
  };
};
